import React, { Component } from 'react'
import { connect } from 'react-redux'

import { goToOrganizationUpgrade } from 'data/ui/actions'

import List from './List'
import Create from './Create'
import Update from './Update'
import Show from './Show'

class SettingsUserGroups extends Component {
  // Note: I'd rather use the router to do that but Settings page have their own routing stuff
  state = {
    view: 'list',
    options: {},
  }

  render() {
    switch (this.state.view) {
      case 'create':
        return <Create goToList={this.goToList} />
      case 'update':
        return (
          <Update
            goToList={this.goToList}
            userGroupId={this.state.options.groupId}
          />
        )
      case 'show':
        return (
          <Show
            goToList={this.goToList}
            userGroupId={this.state.options.groupId}
          />
        )
      case 'list':
      default:
        return (
          <List
            goToCreateGroup={this.goToCreateGroup}
            goToUpdateGroup={this.goToUpdateGroup}
            goToShowGroup={this.goToShowGroup}
          />
        )
    }
  }

  goToCreateGroup = () => {
    this.setState({ view: 'create', options: null })
  }
  goToList = () => {
    this.setState({ view: 'list', options: null })
  }
  goToUpdateGroup = groupId => {
    this.setState({ view: 'update', options: { groupId } })
  }
  goToShowGroup = groupId => {
    this.setState({ view: 'show', options: { groupId } })
  }
}

export default connect(
  null,
  { goToOrganizationUpgrade }
)(SettingsUserGroups)
